import { INgayNghi } from "../../../models/response/category/INgayNghi";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eNgayNghiActionTypeIds {
    LOAD_START = "NGAY_NGHI_LOAD_START",
    LOAD_SUCCESS = "NGAY_NGHI_LOAD_SUCCESS",
    LOAD_ERROR = "NGAY_NGHI_LOAD_ERROR",

    SAVE_START = "NGAY_NGHI_SAVE_START",
    SAVE_SUCCESS = "NGAY_NGHI_SAVE_SUCCESS",
    SAVE_ERROR = "NGAY_NGHI_SAVE_ERROR",

    DELETE_START = "NGAY_NGHI_DELETE_START",
    DELETE_SUCCESS = "NGAY_NGHI_DELETE_SUCCESS",
    DELETE_ERROR = "NGAY_NGHI_DELETE_ERROR",

    SHOW_EDIT_MODAL = "NGAY_NGHI_SHOW_EDIT_MODAL",
    CLOSE_EDIT_MODAL = "NGAY_NGHI_CLOSE_EDIT_MODAL",
}

export interface INgayNghiLoadStart extends IActionTypeBase<eNgayNghiActionTypeIds.LOAD_START, undefined> {}
export interface INgayNghiLoadSuccess extends IActionTypeBase<eNgayNghiActionTypeIds.LOAD_SUCCESS, INgayNghi[]> {}
export interface INgayNghiLoadError extends IActionTypeBase<eNgayNghiActionTypeIds.LOAD_ERROR, string> {}

export interface INgayNghiSaveStart extends IActionTypeBase<eNgayNghiActionTypeIds.SAVE_START, INgayNghi> {}
export interface INgayNghiSaveSuccess extends IActionTypeBase<eNgayNghiActionTypeIds.SAVE_SUCCESS, undefined> {}
export interface INgayNghiSaveError extends IActionTypeBase<eNgayNghiActionTypeIds.SAVE_ERROR, string> {}

export interface INgayNghiDeleteStart extends IActionTypeBase<eNgayNghiActionTypeIds.DELETE_START, number> {}
export interface INgayNghiDeleteSuccess extends IActionTypeBase<eNgayNghiActionTypeIds.DELETE_SUCCESS, undefined> {}
export interface INgayNghiDeleteError extends IActionTypeBase<eNgayNghiActionTypeIds.DELETE_ERROR, string> {}

export interface INgayNghiShowEditModal extends IActionTypeBase<eNgayNghiActionTypeIds.SHOW_EDIT_MODAL, INgayNghi | undefined> {}
export interface INgayNghiCloseEditModal extends IActionTypeBase<eNgayNghiActionTypeIds.CLOSE_EDIT_MODAL, undefined> {}

export type INgayNghiActionTypes =
    | INgayNghiLoadStart
    | INgayNghiLoadSuccess
    | INgayNghiLoadError
    | INgayNghiSaveStart
    | INgayNghiSaveSuccess
    | INgayNghiSaveError
    | INgayNghiDeleteStart
    | INgayNghiDeleteSuccess
    | INgayNghiDeleteError
    | INgayNghiShowEditModal
    | INgayNghiCloseEditModal;
